import { atom } from "jotai";

import { getDictTree } from "@/api/system/dictionaries";
import type { DictTreeItemVO } from "@/api/system/dictionaries/type";

/** 全量数据字典树（顶层为字典类型，children 为字典项） */
export const dictionariesAtom = atom<DictTreeItemVO[]>([]);

/** 字典是否已完成首次加载 */
export const dictReadyAtom = atom(false);

/**
 * 拉取并写入全量字典树
 * 字典配置页 CRUD 成功后 dispatch 此 atom 刷新
 */
export const refreshDictionariesAtom = atom(null, async (_get, set) => {
  try {
    const res = await getDictTree();
    // 接口 data 可能为 null，统一落成空数组避免下游 find 报错
    set(dictionariesAtom, res.data ?? []);
  } catch {
    set(dictionariesAtom, []);
  } finally {
    set(dictReadyAtom, true);
  }
});

/**
 * 首次加载字典（已就绪则跳过，避免 refresh 时闪烁）
 * bootstrap 完成后后台调用，不阻塞鉴权
 */
export const initDictionariesAtom = atom(null, async (get, set) => {
  if (get(dictReadyAtom)) return;
  await set(refreshDictionariesAtom);
});
